import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import SVG from "./outline/executive-overboarding.svg";
var ExecutiveOverboardingOutline_default = forwardRef(
  (props, ref) => /* @__PURE__ */ jsx(SVG, { ref, ...props })
);
export {
  ExecutiveOverboardingOutline_default as default
};
